<template>
  <div>
    <el-dialog :visible.sync="dialogCodeVisible" top="2%" @close="handleCancel">
      <span slot="title">请选择审方形式</span>
      <div class="pass-reject-box" v-loading="loading">
        <div class="pass-reject-tip">
          <span style="color: #ff3939">*</span>
          <span>请选择线下审方或线上审方形式。</span>
        </div>
        <div class="pass-reject-title">注册药师</div>
        <div class="pass-reject-content">
          <el-radio-group
            v-model="selectedPharmacist"
            @change="handlePharmacistChange"
          >
            <el-radio
              v-for="pharmacist in onlinePharmacists"
              :key="pharmacist.openId"
              :label="pharmacist.openId"
              :disabled="pharmacist.reason === '离岗'"
            >
              {{ pharmacist.realName
              }}<span v-if="pharmacist.reason === '离岗'">
                ({{ pharmacist.reason }})
              </span>
            </el-radio>
          </el-radio-group>
        </div>
        <div class="pass-reject-title" v-if="remotePharmacists.length > 0">
          远程审方员
        </div>
        <div class="pass-reject-content" v-if="remotePharmacists.length > 0">
          <el-checkbox-group
            v-model="selectedRemotePharmacists"
            @change="handleRemotePharmacistChange"
          >
            <el-checkbox
              v-for="pharmacist in remotePharmacists"
              :key="pharmacist.openId"
              :label="pharmacist.openId"
            >
              {{ pharmacist.realName }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="pass-reject-button">
          <el-button plain @click="handleCancel">取消</el-button>
          <el-button
            type="primary"
            :disabled="
              !selectedPharmacist && selectedRemotePharmacists.length === 0
            "
            @click="handleSubmit"
            >确定</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "PassReject",
  components: {},
  props: {},
  data() {
    return {
      dialogCodeVisible: false,
      loading: false,
      onlinePharmacists: [],
      remotePharmacists: [],
      selectedPharmacist: "",
      selectedRemotePharmacists: [],
      form: {},
    };
  },
  methods: {
    handleCancel() {
      this.selectedPharmacist = "";
      this.selectedRemotePharmacists = [];
      this.onlinePharmacists = [];
      this.remotePharmacists = [];
      this.dialogCodeVisible = false;
    },
    async handleSubmit() {
      let pharmacists = [];
      let auditType = "";
      if (this.selectedPharmacist) {
        auditType = 0;
        let pharmacist = this.onlinePharmacists.find(
          (item) => item.openId === this.selectedPharmacist
        );
        if (pharmacist) {
          pharmacists.push(pharmacist);
        }
      }
      if (this.selectedRemotePharmacists.length > 0) {
        auditType = 1;
        let pharmacist = this.remotePharmacists.filter((item) =>
          this.selectedRemotePharmacists.includes(item.openId)
        );
        if (pharmacist.length > 0) {
          pharmacists.push(...pharmacist);
        }
      }
      this.loading = true;
      const { code, message } = await this.$api.prescription.SubmitPrescription(
        {
          prescriptionId: this.form.id,
          auditType,
          pharmacists,
        }
      );
      this.loading = false;
      if (code === 500) {
        this.$message({
          message: message || "审核失败",
          type: "error",
        });
        return;
      }
      this.$message({
        message: "审核成功",
        type: "success",
      });
      this.dialogCodeVisible = false;
      this.$emit("submit");
    },
    handlePharmacistChange(val) {
      this.selectedRemotePharmacists = [];
    },
    handleRemotePharmacistChange(val) {
      this.selectedPharmacist = "";
    },
    async show(row) {
      this.dialogCodeVisible = true;
      this.form = row;
      this.loading = true;
      const { data } =
        await this.$api.prescription.GetPrescriptionPharmacists();
      this.onlinePharmacists = data.onlinePharmacists || [];
      this.remotePharmacists = data.remotePharmacists || [];
      this.loading = false;
    },
  },
};
</script>

<style scoped>
::v-deep .el-dialog__header {
  background: #f7f7f7 !important;
  border-radius: 4px 4px 0px 0px !important;
  border-bottom: 1px solid #dcdcdc !important;
}
</style>
<style lang="scss" scoped>
@import "./passReject.scss";
</style>
